import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { OptimizelyProvider } from "@optimizely/react-sdk";
import { HelmetProvider } from "react-helmet-async";

import { ApplicationWrapper } from "containers/ApplicationWrapper";
import { ErrorBoundary } from "./ApplicationWrapper/Bugsnag";
import "../main.scss";

const App = ({ store, optimizelyClient = null, optimizelyUser = null }) => {
	const {
		user: { visitId }
	} = store.getState();
	const user = optimizelyUser || { id: visitId };

	return (
		<HelmetProvider>
			<Provider store={store}>
				<OptimizelyProvider
					optimizely={optimizelyClient}
					user={user}
				>
					<ErrorBoundary>
						<BrowserRouter
							future={{
								v7_startTransition: true,
								v7_relativeSplatPath: true
							}}
						>
							<ApplicationWrapper />
						</BrowserRouter>
					</ErrorBoundary>
				</OptimizelyProvider>
			</Provider>
		</HelmetProvider>
	);
};

App.propTypes = {
	store: PropTypes.object.isRequired,
	optimizelyClient: PropTypes.object,
	optimizelyUser: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.object
	})
};

export default App;
